import * as React from 'react';

import { Box } from '~shared/components/Box';
import { UseIconProps, useIcon } from '../../useIcon';
import { IconAnswerKeySvg } from './IconAnswerKeySvg';

export type IconAnswerKeyProps = UseIconProps;

export function IconAnswerKey(props: IconAnswerKeyProps) {
  const iconProps = useIcon(props);
  return <Box tagName={IconAnswerKeySvg} {...iconProps} />;
}